import scrollEvent from '../../components/fsUtils/scrollEvent';

class AnchorNav {
    constructor(){
        this.header = document.getElementById('body-header-wrapper');
        this.scorestrip = document.getElementById('ScorestripContainer');
        this.scorestripHeght = this.scorestrip ? this.scorestrip.clientHeight : 65;
        this.mainNav = document.getElementById('header-wrapper');
        this.mainNavHeight = this.mainNav ? this.mainNav.clientHeight : 45;
        this.headerHeight = this.header ? this.header.clientHeight : 111;
        this.anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
        if( ! this.anchorNavWrapper ) return;
        this.anchorNavContainer = this.anchorNavWrapper.querySelector('.anchor-nav-container');
        this.anchorWrap = this.anchorNavWrapper.querySelector('.nav-wrap');
        this.anchorNav = this.anchorNavWrapper.querySelector('.anchor-nav');
        this.outsideNavLinks = document.querySelectorAll('.outside-nav-link');
        if(this.anchorNavWrapper) {
            this.anchorNavLinks = this.anchorNavWrapper.querySelectorAll('a');
            this.leftArrow = document.querySelector('.left-arrow');
            this.rightArrow = document.querySelector('.right-arrow'); 
        }
        
        this.isTopPinEnabled = true;
        this.pinWrapper = undefined;
        this.pinWrapperHeight = 0;
        this.travelDistance = 150; 
        this.scrollPerTick = 10;
        this.lastId = undefined;
        this.currentId = undefined;
        this.items = [];
        this.throttle = ('ontouchstart' in document.documentElement) ? 50 : 10;
        this.navHandler();
        this.lastScrollTop = 0;
        this.pinner = this.pinHandler.bind(this);
        this.pinner = scrollEvent.throttle(this.pinner, this.throttle);

        document.addEventListener("DOMContentLoaded", function(event) { 
            this.navArrowHandler();
        }.bind(this));

        //handle pinning and active menu items
        window.addEventListener('scroll', this.pinner);
    }
    /**
     * Scrolls into view the anchorlection item the user clicks on
     */
    navHandler(){
        if(this.anchorNavLinks){
            for (let i = 0, l = this.anchorNavLinks.length; i < l; i++) {
                let link = this.anchorNavLinks[i];
                this.addClickEvent(link, i);
            }
        }

        if (this.outsideNavLinks) {
            for (let i = 0, l = this.outsideNavLinks.length; i < l; i++) {
                let link = this.outsideNavLinks[i];
                let idx = parseInt((link.getAttribute('href') || '').replace(/\D/g,''));

                if (!isNaN(idx)) {
                    this.addClickEvent(link, idx, true);
                }
            }
        }
    }

    addClickEvent(link, idx, isOutsideLink) {
        link.addEventListener('click', (e)=>{
            e.preventDefault();

            let container = document.querySelectorAll('.anchor-container > div')[idx];
            if(container){
                scrollEvent.scrollTo( container, this.headerHeight + this.anchorNavWrapper.clientHeight);

                let selectedLink = this.anchorNav.querySelector('a.selected');
                if(selectedLink){
                    selectedLink.classList.remove('selected');
                }

                if (isOutsideLink) {
                    let navLink = this.anchorNav.querySelectorAll('a')[idx];
                    if (navLink) {
                        navLink.classList.add('selected');
                    }
                } else {
                    link.classList.add('selected');
                }
            }
        });
    }

    pinHandler() {
        if (this.header) this.headerHeight = this.header.clientHeight;
        let mainNavTop = this.mainNav.getBoundingClientRect().top;
        let anchorRect =  this.anchorNavWrapper.getBoundingClientRect(); //In order to get the pin off set properly, we need this.
        let st = window.pageYOffset || document.documentElement.scrollTop;
        
        let offset = anchorRect.top - this.mainNavHeight;
        if(this.isTopPinEnabled) {
            let isTopVideoPinned = document.body.classList.contains('player-pinned');
            if(isTopVideoPinned) {
                this.pinWrapper = document.querySelector('.fs-pin-wrapper.pin-player');
                if(this.pinWrapper) {
                    offset = offset - this.pinWrapper.clientHeight;
                    this.headerHeight = this.headerHeight + this.pinWrapper.clientHeight;
                }
            }
        }

        //down
        if (st > this.lastScrollTop) {
            if(anchorRect.top !== 0 && offset < mainNavTop) {
                if( this.anchorNavContainer && ! this.anchorNavContainer.classList.contains('fixed') ) {
                    this.anchorNavContainer.classList.add('fixed');
                }
            }
        }
        else { //up
            if( anchorRect.top > this.headerHeight && this.anchorNavContainer.classList.contains('fixed') ){
                this.anchorNavContainer.classList.remove('fixed');
            }
        }
        this.lastScrollTop = st;

        if(this.items.length <= 1){
            this.items = document.querySelectorAll('.anchor-container > div');
        } else {
            //get current div in view
            for (let i = 0, l = this.items.length; i < l; i++) {
                if((scrollEvent.getCoords(this.items[i]).top - (this.anchorNavWrapper.clientHeight + this.header.clientHeight + 1) ) < window.scrollY) {
                    this.currentId = i;
                }
            }

            //add the selected class if ids do not match
            if(this.lastId !== this.currentId){
                this.lastId = this.currentId;
                let link =  this.anchorNav.querySelectorAll('a')[this.currentId];
                let selectedLink = this.anchorNav.querySelector('a.selected');
                if(selectedLink){
                    selectedLink.classList.remove('selected');
                }
                if(link && !link.classList.contains('selected')) {
                    link.classList.add('selected');
                    let linkLeftPos = link.getBoundingClientRect().x || link.getBoundingClientRect().left;
                    let anchorLeftPos =  this.anchorNav.getBoundingClientRect().x ||  this.anchorNav.getBoundingClientRect().left;
                    let travelDistance = (linkLeftPos - anchorLeftPos);
                    this.anchorNav.scrollLeft += travelDistance;
                }
            }
        }
    }

    /**
     * Scrolls right or left when clicking on arrows on anchor nav
     */
    navArrowHandler(){
        //set direction when page load
        let navUl = this.anchorNav.querySelector('ul');
        if( this.anchorWrap ) {
            let flowDirection = this.getFlowDirection(navUl, this.anchorNav);
            this.anchorWrap.setAttribute('direction', flowDirection );
    
            this.leftArrow.addEventListener('click', (e) => {
                let scrollAmount = 0;
                let slideTimer = setInterval(() => {
                    this.anchorNav.scrollLeft -= this.scrollPerTick;
                    scrollAmount += this.scrollPerTick;
                    if(scrollAmount >= this.travelDistance){
                        window.clearInterval(slideTimer);
                    }
                }, 15);
                let flowDirection = this.getFlowDirection(navUl, this.anchorNav);
                this.anchorWrap.setAttribute('direction', flowDirection );
            })
            this.rightArrow.addEventListener('click', (e) => {
                let scrollAmount = 0;
                let slideTimer = setInterval(() => {
                    this.anchorNav.scrollLeft += this.scrollPerTick;
                    scrollAmount += this.scrollPerTick;
                    if(scrollAmount >= this.travelDistance){
                        window.clearInterval(slideTimer);
                    }
                }, 15);
                let flowDirection = this.getFlowDirection(navUl, this.anchorNav);
                this.anchorWrap.setAttribute('direction', flowDirection );

            })
    
            this.anchorNav.addEventListener('scroll', (e) => {
                let flowDirection = this.getFlowDirection(navUl, this.anchorNav);
                this.anchorWrap.setAttribute('direction', flowDirection );
            });
        }
    }

    /**
     * 
     * @param {*} ul 
     * @param {*} container 
     */
    getFlowDirection(ul, container) {
        var containerMetrics = container.getBoundingClientRect();
        var containerMetricsRight = Math.floor(containerMetrics.right);
        var containerMetricsLeft = Math.floor(containerMetrics.left);
        var contentMetrics = ul.getBoundingClientRect();
        var contentMetricsRight = Math.floor(contentMetrics.right);
        var contentMetricsLeft = Math.floor(contentMetrics.left);
         if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
            return "both";
        } else if (contentMetricsLeft < containerMetricsLeft) {
            return "left";
        } else if (contentMetricsRight > containerMetricsRight) {
            return "right";
        } else {
            return "none";
        }
    }



}

export default AnchorNav;